exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-project {\n  background-color: #ffffff;\n  border-radius: 2px;\n}\n.tabs-project .nav-tabs {\n    flex-wrap: inherit !important;\n}\n", ""]);

// exports
